import OnboardingWebHeader, { getOnboardingWebHeaderStyles } from './View/index.web';

export { OnboardingWebHeader, getOnboardingWebHeaderStyles };
